export default function CGV() {
  return (
    <div className="legal">
      <h1>Conditions Générales de Vente</h1>

      <p>
        Les présentes conditions générales de vente définissent les droits et obligations
        des parties dans le cadre de la vente de prestations de création de sites web.
      </p>

      <h2>1. Prestations</h2>
      <p>
        Le prestataire propose des services de création de sites internet, incluant :
        conception, développement, intégration, optimisation et mise en ligne.
      </p>

      <h2>2. Commande</h2>
      <p>
        Toute commande est validée après accord écrit (email ou devis signé).
        La commande implique l’acceptation pleine et entière des présentes CGV.
      </p>

      <h2>3. Tarifs</h2>
      <p>
        Les prix des prestations sont indiqués sur devis. Ils sont exprimés en euros
        et peuvent être modifiés à tout moment avant validation de la commande.
      </p>

      <h2>4. Paiement</h2>
      <p>
        Le paiement s’effectue selon les modalités définies sur le devis.
        Un acompte peut être demandé avant le début du projet.
      </p>

      <h2>5. Délais de réalisation</h2>
      <p>
        Les délais de livraison sont donnés à titre indicatif et peuvent varier
        en fonction de la complexité du projet et des échanges avec le client.
      </p>

      <h2>6. Obligations du client</h2>
      <p>
        Le client s’engage à fournir toutes les informations nécessaires à la réalisation du projet
        (textes, images, contenus, accès éventuels).
      </p>

      <h2>7. Propriété intellectuelle</h2>
      <p>
        Le site devient la propriété du client après paiement complet.
        Le prestataire se réserve le droit de mentionner la réalisation comme référence.
      </p>

      <h2>8. Responsabilité</h2>
      <p>
        Le prestataire ne peut être tenu responsable des dommages indirects liés à l’utilisation du site
        ou à une mauvaise utilisation par le client.
      </p>

      <h2>9. Maintenance</h2>
      <p>
        La maintenance n’est pas incluse sauf mention contraire sur le devis.
        Elle peut faire l’objet d’un contrat séparé.
      </p>

      <h2>10. Litiges</h2>
      <p>
        En cas de litige, une solution amiable sera privilégiée.
        À défaut, les tribunaux français seront compétents.
      </p>
    </div>
  );
}